import React from 'react';
import { Target, Wrench, CheckCircle, TrendingUp } from 'lucide-react';
import { aboutContent } from '../mock';

export const About = () => {
  const highlights = [
  {
    icon: Target,
    title: "Expertise",
    description: "30+Years of experience in manufacturing vulcanizing machines"
  },
  {
    icon: Wrench,
    title: "Customization",
    description: "Tailor-made engineering solutions for your needs"
  },
  {
    icon: CheckCircle,
    title: "Quality",
    description: "Commitment to excellence and customer satisfaction"
  },
  {
    icon: TrendingUp,
    title: "Consultancy",
    description: "Expert guidance at every stage from concept to commissioning\xA0 tailored to your production goals"
  }];


  return (
    <section id="about" className="py-16 md:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {aboutContent.title}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <p className="text-lg text-slate-700 leading-relaxed">
              {aboutContent.description}
            </p>
          </div>
          <div className="grid grid-cols-2 gap-6">
            {highlights.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">

                  <Icon size={32} className="text-blue-600 mb-3" />
                  <h3 className="text-lg font-semibold text-slate-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-slate-600">
                    {item.description}
                  </p>
                </div>);

            })}
          </div>
        </div>
      </div>
    </section>);

};